import StoryPreviewCard from './StoryPreviewCard';

export default StoryPreviewCard;
